import { render, staticRenderFns } from "./ExpenseDetailsPdf.vue?vue&type=template&id=6f66bd6c&scoped=true&"
import script from "./ExpenseDetailsPdf.vue?vue&type=script&lang=js&"
export * from "./ExpenseDetailsPdf.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseDetailsPdf.vue?vue&type=style&index=0&id=6f66bd6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f66bd6c",
  null
  
)

export default component.exports